module.exports = __webpack_public_path__ + "static/media/h-quadrado.5fdd6e8d.svg";